<template>
  <div class="businessAdd">
    <div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <!-- 第一块 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>联系人信息</span> <span>该手机号即为核销登录手机号</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label"><i class="red">*</i>联系人姓名</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="merchantUserRealname">
            </div>
            <div class="label"> <i class="red">*</i> 联系人手机</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="merchantUserCellphone">
            </div>
          </div>
          <!-- <div class="oneLine">
            <div class="label"> <i class="red">*</i> 联系人手机</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="merchantUserCellphone">
            </div>
          </div> -->
        </div>
      </div>
      <!-- 第2块 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>店铺信息</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label"><i class="red">*</i>店铺名称</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="storeName">
            </div>
            <div class="label"> <i class="red">*</i> 所在园区</div>
            <div class="rightInput">
              <select name="" id="" v-model="itsLocation">
                <option :value="list.value" v-for="(list,index) in parkWord" :key="index">{{list.text}}</option>
              </select>
            </div>
            <div class="label">店铺在园区的店铺列表排序（数字越大越靠上）</div>
            <div class="rightInput">
              <el-input-number v-model="storeListSequence"  :min="0" :max="100000000" label="描述文字"></el-input-number>
            </div>
          </div>
          <div class="oneLine">

          </div>
          <div class="oneLine">
            <div class="label">店面照片</div>
            <div class="rightInput myFixedRateImgUpload">
              <!-- :on-remove="handleRemove"  -->
              <el-upload
               :file-list="dianmianImgInfoArr_string"
               :name="'files'"
               :data="uploadData"
               :action="api.baseUrl+'/file/uploadfilebatch'"
               :on-success="addImgSuccessHandle"
               list-type="picture-card">
                <div class="mytriggerDiv" slot="trigger" @click="addImgClick('dianmian')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
                <!-- <i slot="default" class="el-icon-plus"></i> -->
                <div slot="file" slot-scope="{file}">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url" alt=""
                  >
                  <span class="set-main">
                    <el-checkbox v-model="file.isMain"
                      @change="handleSelectMain(file)"
                    >设为主图</el-checkbox>
                  </span>
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </div>
          </div>
          <div class="oneLine">
            <div class="label"><i class="red">*</i>店铺地址</div>
            <div class="rightInput">
              <!-- <el-cascader placeholder="点击选择地址" :clearable="true"  ref="cascader" :props="props" @change="handleChangeAddress"></el-cascader> -->
              <addressSelect :proviceId="proviceId" :cityId="cityId" :distId="distId"  @changeSelect="changeAddress"></addressSelect>
              <input type="text" class="input" placeholder="请输入详细地址" v-model="addressString">
            </div>
            <!-- <br> -->
            <div class="label"><i class="red">*</i>经度</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="storeLongitude">
            </div>
            <div class="label"><i class="red">*</i>纬度</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="storeLatitude">
            </div>
          </div>
          <div class="oneLine">
            <!-- <div class="label">地图插件</div> -->
            <div class="rightInput">
              <div id="mapContainer">
              </div>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">主营类目（最多三个）</div>
            <div class="rightInput">
              <span v-for="(list,index) in mainCategory" class="mainTypeSpan">

                <span class="mainTypeText">{{list}}</span>
                <span class="mainTypeDelete"><i class="el-icon-delete" @click="deleteMainType(index)"></i></span>
              </span>
              <el-cascader :options="optionsCategory" placeholder="点击选择类目" :clearable="true"
               ref="cascaderCategory" @change="handleChangeCategory" v-show="!(mainCategory.length>=3) "></el-cascader>
            </div>

          </div>
          <div class="oneLine">
            <div class="label">价格区间</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入开始" v-model="startPrice">-
              <input type="text" class="input" placeholder="请输入结束" v-model="endPrice">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">营业时间</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="openTime">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">店铺介绍</div>
            <div class="rightInput">
              <textarea name="" id="" cols="50" rows="5" placeholder="请输入店铺介绍" v-model="parkDescribe"></textarea>
            </div>
          </div>

          <div class="oneLine">
            <div class="label">店铺标签</div>
            <div class="rightInput">
              <tagSelect :value="''" :type="'store'" @clickItem="getTag_store"></tagSelect>


            </div>
          </div>


          <div class="oneLine">
            <div class="label">店面地图显示图标：</div>
            <div class="rightInput">
              <tagSelect :value="''" :type="'map_store'" @clickItem="getTag_map" :num="1"></tagSelect>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">店面图标在地图上层级排序（数字越大越靠上）</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入大于等于0的数字" v-model="storeMapSequence">
              <el-input-number v-model="storeMapSequence"  :min="0" :max="100000000" label="描述文字"></el-input-number>
            </div>
          </div>

          <div class="oneLine">
            <div class="label">店铺备注</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="parkRemark">
            </div>
          </div>
        </div>
      </div>
      <!-- 4 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>品牌信息</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label">品牌名称</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="brandName">
            </div>
            <div class="label">所属公司</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="byCompany">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">品牌logo</div>
            <div class="rightInput">
              <el-upload
               :on-remove="handleRemove" :limit="1" :on-exceed="exceedHandle" :file-list="logoImgInfoArr_string"
               :name="'files'" :data="uploadData" :action="api.baseUrl+'/file/uploadfilebatch'" :on-success="addImgSuccessHandle"
               list-type="picture-card">
                <div class="mytriggerDiv" slot="trigger" @click="addImgClick('logo')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <!-- 5 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>优惠信息</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label">折扣</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入折扣信息或其他优惠信息4个字以内" v-model="discountInfo">
            </div>
          </div>
        </div>
      </div>
      <!-- button -->
      <div class="btnBox">
        <el-button type='primary' @click="submitClick">提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>
  import addressSelect from '@/components/addressSelect'
  import {
    json,
    wordData,
    utils
  } from '@/common/common.js'
  import {
    ajaxPost,
    api
  } from '@/common/request.js'
  import AMap from 'AMap'
  export default {
    name: 'adminIndex',
    data() {
      return {
        optionsCategory:[],
        isLoading: "",
        storeName: "",
        storeMapSequence:0,
        storeListSequence:0,
        itsLocation: "",
        storeLongitude: "",
        storeLatitude: "",
        storeTag:[],
        parkOnMapIcon: [],
        merchantUserRealname: "",
        merchantUserCellphone: '',
        parkImg: '门店照片',
        mainCategory: [],
        addressSelect:[],
        startPrice: "",
        list_tag_store:[],
        list_tag_item:[],
        endPrice: "",
        openTime: "",
        parkDescribe: "",
        parkWord:[],
        brandName: "",
        brandLogo: "",
        byCompany: "",
        discountInfo: "",
        parkRemark: "",
        //
        imageType:'',
        uploadData:{},
        dianmianImgInfoArr_string:[],//存储图片名字和其后台返回的id
        logoImgInfoArr_string:[],//存储图片名字和其后台返回的id

        // ditu
        proviceText: "",
        cityText: '',
        distText: '',
        proviceId: "",
        cityId: '',
        distId: '',
        addressString: '', //详细地址
        // props: {
        //   lazy: true,
        //   lazyLoad(node, resolve) {
        //     console.log(node)
        //     const {
        //       level
        //     } = node;
        //     let nodeId = node.value || 0
        //     let arg = {
        //       parentId: nodeId
        //     }
        //     ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
        //       if (res.errorCode == 200) {
        //         let lists = res.data || [{
        //           region_id: node.value + 'mm',
        //           region_name: node.label
        //         }]
        //         // let lists=res.data
        //         let newArr = lists.map(function(item, index) {
        //           let buffer = {
        //             value: item.region_id,
        //             label: item.region_name,
        //             leaf: level >= 2,
        //           }
        //           return buffer
        //         })
        //         resolve(newArr);
        //       }
        //     }, function(res) {})

        //   }
        // }

      }
    },
    computed: {
      IMG_PREV() {
        return api.imgPrev
      },
      api(){
        return api
      },
      adminId() {
          return utils.getAdminId()
      },
    },
    components: {addressSelect},
    methods: {
      deleteMainType(index){
        this.mainCategory.splice(index,1)
      },
      getTag_map(data){
        this.parkOnMapIcon=data
      },
      getTag_store(data){
        this.storeTag=data
      },
      exceedHandle(){
        alert("只允许上传一张")
      },
      handleRemove(file, fileList) {
        if(file.wwType=='11401'){//logo
          // this.logoImgInfoArr_string=this.computeImgIdArrToString(fileList)
          this.logoImgInfoArr_string=fileList;
        }
        if(file.wwType=='11301'){//dianmian
          // this.dianmianImgInfoArr_string=this.computeImgIdArrToString(fileList)
          this.dianmianImgInfoArr_string= this.dianmianImgInfoArr_string.filter(item => item.uid != file.uid );
        }
      },
      computeImgIdArrToString(fileList){
        let idArr=[]
        for(var i=0;i<fileList.length;i++){
          let oneItem=fileList[i]
          let str=oneItem.wwId
          let arr=str.split(",")
          for(var j=0;j<arr.length;j++){
            let smallItem=arr[j]
            idArr.push(smallItem)
          }

        }
        return idArr.join(",")
      },
      turnImgIdToJson(str){
        console.log(str)
        let result=''
        if(str){
          let arr=str.split(",")
          let newArr=arr.map(function(item,index){
            return JSON.parse(item)
          })
          console.log(newArr)
          result=JSON.stringify(newArr)
        }else{
          result=""
        }
        console.log(result)
        return result

      },
      addImgSuccessHandle(res, file,fileList){//自动上传成功以后的操作
        console.log("上传图片成功---")
        console.log(this.imageType)
        console.log(file, fileList);
        if(res.errorCode==200){
          file.wwId=res.data
          file.wwType=this.imageType
          if(this.imageType=='11401'){//logo
            // this.logoImgInfoArr_string=this.computeImgIdArrToString(fileList)
            this.logoImgInfoArr_string=fileList
          }
          if(this.imageType=='11301'){//dianmian
            // this.dianmianImgInfoArr_string=this.computeImgIdArrToString(fileList)
            this.dianmianImgInfoArr_string=fileList
          }
        }

      },
      addImgClick(type){//点击不同的图片上传按钮，设置imagetype及图片data
        console.log('点击上传按钮---'+type)
        if(type=='logo'){
           this.imageType=11401
           this.uploadData = {
               imageType: this.imageType,
               imageUserId: this.adminId,
           }
           // console.log(this.uploadData)
        }
        if(type=='dianmian'){
           this.imageType=11301
           this.uploadData = {
               imageType: this.imageType,
               imageUserId: this.adminId,
           }
           // console.log(this.uploadData)
        }
      },
      // 选择主图
      handleSelectMain(file, fileList) {
        console.log(file);
        this.dianmianImgInfoArr_string.forEach(item => {
          if (file.uid == item.uid) {
            item.isMain = true
          } else {
            item.isMain = false
          }
        })
      },
      submitClick(){
        let _this=this
        if(!this.merchantUserRealname){
          _this.$message({
               message: "联系人姓名必填",
               type: 'error',
          });
          return false
        }
        if(!this.merchantUserCellphone){
          _this.$message({
               message: "联系人手机号必填",
               type: 'error',
          });
          return false
        }
        if(!json.phoneReg.test(this.merchantUserCellphone)){
          _this.$message({
               message: "手机号格式不正确",
               type: 'error',
          });
          return false
        }
        if(!this.proviceId||!this.cityId){
          _this.$message({
               message: "地址必填",
               type: 'error',
          });
          return false
        }
        if(!this.storeLongitude||!_this.storeLatitude){
          _this.$message({
               message: "经纬度必填",
               type: 'error',
          });
          return false
        }
        if(!this.storeName){
          _this.$message({
               message: "店铺名称必填",
               type: 'error',
          });
          return false
        }
        if(isNaN(_this.storeMapSequence)||_this.storeMapSequence<0){
          _this.$message({
               message: "门店地图展示排序只能为大于等于0的数字",
               type: 'error',
          });
          return false
        }
        if(isNaN(_this.storeListSequence)||_this.storeListSequence<0){
          _this.$message({
               message: "门店列表只能为大于等于0的数字",
               type: 'error',
          });
          return false
        }
        if(!this.itsLocation){
          _this.$message({
               message: "店铺所在园区必选",
               type: 'error',
          });
          return false
        }

        let arg={
          adminId:_this.adminId,
          storeName: _this.storeName,
          itsLocation: _this.itsLocation,
          storeLongitude: _this.storeLongitude,
          storeLatitude: _this.storeLatitude,
          storeMapSequence:_this.storeMapSequence,
          storeListSequence:_this.storeListSequence,
          storeTag: _this.storeTag.join(","),
          parkOnMapIcon: _this.parkOnMapIcon.join(","),
          merchantUserRealname: _this.merchantUserRealname,
          merchantUserCellphone: _this.merchantUserCellphone,
          parkImg: utils.turnImgIdToJson_main(_this.dianmianImgInfoArr_string),
          mainCategory:JSON.stringify(_this.mainCategory) ,
          startPrice: _this.startPrice,
          endPrice: _this.endPrice,
          openTime: _this.openTime,
          parkDescribe: _this.parkDescribe,
          brandName: _this.brandName,
          brandLogo: utils.turnImgIdToJson(_this.logoImgInfoArr_string),
          byCompany: _this.byCompany,
          discountInfo: _this.discountInfo,
          parkRemark: _this.parkRemark,
          "regionProvinceId":_this.proviceId,
          "regionProvinceString":_this.proviceText,
          "regionCityId":_this.cityId,
          "regionCityString":_this.cityText,
          "regionDistrictId":_this.distId,
          "regionDistrictString":_this.distText,
          addressString:_this.addressString
        }
        console.log(arg)
        ajaxPost('/store/addStore', arg).then(function(res) {
          if(res.errorCode==200){
            _this.$message({
                 message: "上传商家成功",
                 type: 'success',
            });
            _this.$router.back()

          }else{

          }
        }, function(res) {})

      },
      handleChangeCategory(value){
        console.log(value)
        if(value){
          let str=value.join("-")
          this.mainCategory.push(str)
        }
        // this.mainCategory=value?value.join(","):''
      },
      getTagList(type){
        let _this=this
        console.log(arg)
        let arg={tagType:type}
        ajaxPost('/tag/tagList', arg).then(function(res) {
          if(res.errorCode==200){
            console.log(res)
            let keyname='list_tag_'+type
            _this[keyname]=res.data

          }else{

          }
        }, function(res) {})
      },
      initMap() {
        let _this = this
        let map = new AMap.Map('mapContainer', {
          center: [120.274301, 30.358863],
          resizeEnable: true,
          zoom: 14,
          viewMode: '3D' //使用3D视图
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function() {
          map.addControl(new AMap.ToolBar())
          map.addControl(new AMap.Scale())
        })
        let marker = ''
        map.on("click", function(ev) {
          var lnglat = ev.lnglat;
          console.log("点击地图--")
          var lng = ev.lnglat.getLng()
          var lat = ev.lnglat.getLat()
          _this.storeLongitude = lng //经度
          _this.storeLatitude = lat //维度
          console.log(lng, lat)
          map.remove(marker);
          marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          });
          // 将创建的点标记添加到已有的地图实例：
          map.add(marker);
        })
      },
      back() {
        this.$router.back()
      },
      changeAddress(data){
        // console.log(JSON.stringify(data))
        this.proviceId=data.proviceId
        this.proviceText=data.proviceText
        this.cityId=data.cityId
        this.cityText=data.cityText
        this.distId=data.distId
        this.distText=data.distText
      },
      // handleChangeAddress(value) { //更改地址
      //   console.log("地址change")
      //   let nodesObj = this.$refs['cascader'].getCheckedNodes()
      //   // console.log(nodesObj)
      //   var valueArr = nodesObj[0].path
      //   var TextArr = nodesObj[0].pathLabels
      //   console.log(valueArr)
      //   console.log(TextArr)
      //   // proviceText
      //   this.proviceId = valueArr[0]
      //   this.cityId = valueArr[1]
      //   this.distId = valueArr[2] && valueArr[2].length == 6 ? valueArr[2] : ''
      //   this.proviceText = TextArr[0]
      //   this.cityText = TextArr[1]
      //   this.distText = this.distId ? TextArr[2] : ''
      // },
      getParkWord(){
        let _this=this
        ajaxPost('/park/getParkList', {}).then(function(res) {
          if (res.data) {
            _this.parkWord=[]
            _this.parkWord=res.data.map(function(item,index){
              let buffer={}
              buffer.value=item.park_id
              buffer.text=item.park_name
              return buffer
            })

          }
        }, function(res) {})
      },
      getCategoryWord(){
        let _this = this
        let args = {
          types: 1,
        }
        ajaxPost('/yijiajiaDataCategory/getDatasource', args).then(function(res) {
          if (res.data) {
            _this.optionsCategory=[]
            var arr=res.data.product.list
            arr.forEach(function(item,index){
              let obj={
                value:item.dataName,
                label:item.dataName,
                children:[]
              }
              var childArr=item.list
              childArr.forEach(function(item2,index2){
                let childBuffer={
                  value:item2,
                  label:item2,
                }
                obj.children.push(childBuffer)
              })
              _this.optionsCategory.push(obj)
            })


          }
        }, function(res) {})
      },
      getDetail() {
        let _this = this
        let args = {
          userId: _this.userId,
        }
        ajaxPost('/admin/yijiajiaUserAuth/getUserAuthByAId', args).then(function(res) {
          if (res.data) {
          }

        }, function(res) {})
      },
      initAddress(){
        this.proviceText= "浙江"
        this.cityText= '杭州'
        this.distText= '余杭区'
        this.proviceId= "330000"
        this.cityId= '330100'
        this.distId= '330110'
      }

    },
    mounted() {
      let _this = this
      this.initMap()
      this.getCategoryWord()
      this.getParkWord()
      this.initAddress()

      // this.getTagList('store')
      // this.getTagList('item')//这个换成地图
    },
    destroyed() {

    }
  }
</script>

<style scoped lang="scss">
  * {
    // outline: 1px solid blue;
  }
  #mapContainer {width:900px; height: 500px;border:1px solid #ddd;}
  .businessAdd {
    background: #fff;
    padding: 20px;
    padding-bottom: 100px;

    .panelBlock {
      .panelTitle {
        font-weight: bold;
        padding: 10px 0;
      }

      .panelContent {
        .oneLine {
          padding: 10px;

          .label {
            display: inline-block;
            padding: 0 20px;
          }

          .rightInput {
            display: inline-block;
          }
        }
      }
    }

    .btnBox {
      text-align: center;
    }
  }
  .set-main {
    position: absolute;
    left: -1px;
    top: -1px;
    width: 100px;
    height: 25px;
    background: #fff;
    text-align: center;
    box-shadow: 0 0 1pc 1px rgba(0,0,0,.2);
    border-radius: 4px;
    z-index: 2;
  }
  .mainTypeSpan{
    border:1px solid #409EFF;background:#409EFF ;color:#fff; border-radius: 4px;padding:5px 10px;margin-right: 20px;
    .mainTypeText{margin-right: 20px;}
    .mainTypeDelete{color:#fff;cursor: pointer;padding:0 5px;}
    .mainTypeDelete:hover{color:blue}
  }
</style>



// WEBPACK FOOTER //
// src/pages/business/add.vue